import { createContext } from "react";
import { Client } from "../multistep-form/initial-details/types";
import { SelectedPets } from "../multistep-form/pet-details/types";
import { TimeSlot } from "../multistep-form/book-slot/manually-schedule-modal/types";

export const StepperContext = createContext({
  activeStep: 0,
  setActiveStep: (step: number) => { },
});

export const StepperDataContext = createContext<{
  selectedClient: Client | null;
  setSelectedClient: (client: Client) => void;
  selectedPatients: SelectedPets;
  setSelectedPatients: any;
  selectedTimeSlot: TimeSlot | null;
  setSelectedTimeSlot: any;
  selectedProvider: any;
  setSelectedProvider: (data: any) => void;
  isRescheduleEnabled: boolean;
  setIsRescheduleEnabled: (enabled: boolean) => void;
}>({
  selectedClient: null,
  setSelectedClient: () => { },
  selectedPatients: [],
  setSelectedPatients: () => { },
  selectedTimeSlot: null,
  setSelectedTimeSlot: () => { },
  selectedProvider: {},
  setSelectedProvider: () => { },
  isRescheduleEnabled: false,
  setIsRescheduleEnabled: () => { },
});